module.exports = __webpack_public_path__ + "img/blue-logo-menu.cd8e77cf.svg";